import React, { useEffect } from "react";
import { Card, Button, Table, Layout, Descriptions, Row, Col } from "antd";
import { fmtDateTime } from "../../common/Utils";
import { ApproveReject } from "./components/ApproveReject";
import { UserLink } from "../../components/UserLink/UserLink";
import { observer } from "mobx-react";
import moment from "moment";
import { changeRequestStore } from "../../store/childchange/ChangeRequestStore";
import { useHistory, useLocation } from "react-router-dom";
import { Store } from "../../store/Store";

export const Changes = observer(() => {
  const store = changeRequestStore;

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const getLastName = (name = "") => {
    const strs = name.split(" ");
    return strs[strs.length - 1].toLocaleLowerCase();
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Parent",
      dataIndex: ["pending", "userName"],
      width: "15%",
      key: "parent",
      sorter: (a, b) => getLastName(a.pending.userName).localeCompare(getLastName(b.pending.userName)),
      render: (_, r) => <UserLink userId={r.pending.userId} name={r.pending.userName} />,
    },
    {
      title: "Student",
      dataIndex: ["name"],
      width: "15%",
      key: "childName",
      render: (_, r) => <UserLink childId={r.childId} name={r.name} />,
    },
    {
      title: "Request Time",
      dataIndex: ["pending", "createDate"],
      key: "createDate",
      width: "15%",
      defaultSortOrder: "descend" as const,
      sorter: (a, b) => moment(a.pending.createDate).valueOf() - moment(b.pending.createDate).valueOf(),
      render: (v) => fmtDateTime(v),
    },
    {
      title: "Existing Info",
      key: "old",
      width: "20%",
      render: (_, r) => (
        <Descriptions column={1}>
          {r.attrs.map((x) => (
            <Descriptions.Item key={x.type} label={x.type}>
              {x.from}
            </Descriptions.Item>
          ))}
        </Descriptions>
      ),
    },
    {
      title: "Proposed Info",
      key: "new",
      width: "20%",
      render: (_, r) => (
        <Descriptions column={1}>
          {r.attrs.map((x) => (
            <Descriptions.Item key={x.type} label={x.type}>
              {x.to}
            </Descriptions.Item>
          ))}
        </Descriptions>
      ),
    },
    {
      title: "Approve / Reject",
      key: "opt",
      render: (v, r) => (Store.isDivision ? null : <ApproveReject item={r}></ApproveReject>),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Row>
        <Col md={24} lg={22} xl={20}>
          <Card
            size="small"
            bodyStyle={{ padding: 0 }}
            extra={
              <Button loading={store.loading} size="small" style={{ float: "right" }} onClick={() => store.refresh()}>
                Refresh
              </Button>
            }
          >
            <Table
              size="small"
              pagination={{ ...store.pagination, onChange: onPage }}
              loading={store.loading}
              rowKey="id"
              columns={columns}
              dataSource={store.data.items}
            />
          </Card>
        </Col>
      </Row>
    </Layout.Content>
  );
});
